var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-wrapper padding-videointerview"},[_c('div',{staticClass:"content content_page"},[_c('div',{staticClass:"landing"},[_c('router-view',{staticClass:"landing_content"})],1)])]),_vm._v(" "),_c('vfooter',{attrs:{"type":"landing","background":"#E5E5E5","company_language":_vm.company_language}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }